export default __webpack_public_path__ + "locales/el-GR/PrivacyPage.json?hash=6dcbe328a9f9f8e2ccc2d06ea4854836";